<div class="container">
  <div class="container-padding">
    <h1 class="header m-0">{{ data?.attributeName }}</h1>
  </div>
  <div>
    <mat-tab-group animationDuration="0ms" class="mat-tab-body-content">
      @if (data?.description) {
        <mat-tab label="About">
          <section class="item-cover">
            <h4 class="mb-0">Description</h4>
            <span [innerHTML]="data?.description | safeHtml"></span>
          </section>
        </mat-tab>
      }
      @if (data?.type != 'EncryptedField') {
        <mat-tab label="History">
          <section class="item-cover">
            <field-data-historical-modal-modal
              [attributeName]="data?.attributeName"
              [personId]="data?.personId"
              [teamId]="data?.teamId"
              [entityType]="data?.entityType"
            >
            </field-data-historical-modal-modal>
          </section>
        </mat-tab>
      }
    </mat-tab-group>
  </div>
  <div class="container-padding">
    <button mat-flat-button color="primary" [mat-dialog-close]="true">
      Close
    </button>
  </div>
</div>
